"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastCalledNotAvailableError = void 0;
class LastCalledNotAvailableError extends Error {
    constructor() {
        super("LastCalledNotAvailableError");
    }
}
exports.LastCalledNotAvailableError = LastCalledNotAvailableError;
//# sourceMappingURL=LastCalledNotAvailableError.js.map